'use strict';

var lodash = require('lodash');

const isFieldEmpty = (arg)=>{
    return arg == null || // Check for null or undefined
    arg === '' || // Check for empty string
    typeof arg === 'object' && !(arg instanceof Date) && Object.keys(arg).length === 0 // Check for empty object or array
    ;
};
const processValues = ({ values, subsetValues = values, keyPath, getFieldState, ignoredSubFormFields })=>{
    const validValues = {};
    Object.keys(subsetValues).forEach((key)=>{
        const typedKey = keyPath != null ? `${keyPath}.${key}` : key;
        const fieldState = getFieldState(typedKey);
        const isFieldInvalid = fieldState.invalid;
        const isValueEmpty = isFieldEmpty(lodash.get(values, typedKey));
        // ignore specified fields with sub forms
        if (ignoredSubFormFields?.includes(typedKey)) {
            return;
        }
        /**
         * Even if the field is invalid, we should still add it to validValues if it is empty.
         * Examples:
         * - Empty required text fields are invalid, but should still be added to validValues because we want to allow empty values.
         * - Dates like 0000-00-00 are invalid and should not be added to validValues because they are not empty.
         * - Empty optional text fields are valid, and should be added to validValues because they are empty.
         */ if (isFieldInvalid && !isValueEmpty) {
            return;
        }
        lodash.merge(validValues, lodash.pick(values, typedKey));
    });
    return validValues;
};

exports.isFieldEmpty = isFieldEmpty;
exports.processValues = processValues;
//# sourceMappingURL=processValues.js.map
